import * as React from 'react';

const SvgArrowRightSmall = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.5684 5.82753L19.1799 11.9981L13.5698 18.1728L12.0895 16.8279L15.5671 13.0003L4.82854 13.0003V11.0003L15.5692 11.0003L12.0887 7.17313L13.5684 5.82753Z", fill: "currentColor" }));

export { SvgArrowRightSmall as default };
